import React from 'react';

const BookCover = ({ book }) => {
  if (book.coverImage) {
    return (
      <div className="h-[500px] rounded-xl shadow-2xl flex items-center justify-center p-8 transform hover:scale-105 transition-transform duration-300 bg-white">
        <img 
          src={book.coverImage} 
          alt={`${book.title} book cover`}
          className="h-full w-auto object-contain rounded-lg shadow-xl"
        />
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-emerald-500 to-emerald-700 h-[500px] rounded-xl shadow-2xl flex items-center justify-center p-8 transform hover:scale-105 transition-transform duration-300 overflow-y-auto">
      <div className="text-center">
        <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-4">
          <p className="text-white/95 text-sm font-semibold">Seeking Publisher</p>
        </div>
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-6 leading-tight">
          Sex, Real Estate, and Bad Decisions in Downtown LA
        </h2>
        <p className="text-white/95 leading-relaxed max-w-md mx-auto text-base">
          A British lothario librarian, a homeless man, an aging anchorwoman, a bisexual writer, and an aspiring Black comic are a few of the Downtown denizens caught up in exhibitionism, infidelity, bribery, and stand-up comedy who draw Nora into their dysfunctional world.
        </p>
      </div>
    </div>
  );
};

export default BookCover;
